var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningOctagon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5V12.75",
    stroke: "#CE3637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4173 3H8.58274C8.48425 3 8.38672 3.0194 8.29573 3.05709C8.20473 3.09478 8.12205 3.15003 8.05241 3.21967L3.21967 8.05241C3.15003 8.12205 3.09478 8.20473 3.05709 8.29573C3.0194 8.38672 3 8.48425 3 8.58274V15.4173C3 15.5158 3.0194 15.6133 3.05709 15.7043C3.09478 15.7953 3.15003 15.8779 3.21967 15.9476L8.05241 20.7803C8.12205 20.85 8.20473 20.9052 8.29573 20.9429C8.38672 20.9806 8.48425 21 8.58274 21H15.4173C15.5158 21 15.6133 20.9806 15.7043 20.9429C15.7953 20.9052 15.8779 20.85 15.9476 20.7803L20.7803 15.9476C20.85 15.8779 20.9052 15.7953 20.9429 15.7043C20.9806 15.6133 21 15.5158 21 15.4173V8.58274C21 8.48425 20.9806 8.38672 20.9429 8.29573C20.9052 8.20473 20.85 8.12205 20.7803 8.05241L15.9476 3.21967C15.8779 3.15003 15.7953 3.09478 15.7043 3.05709C15.6133 3.0194 15.5158 3 15.4173 3Z",
    stroke: "#CE3637",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.25C12.6213 17.25 13.125 16.7463 13.125 16.125C13.125 15.5037 12.6213 15 12 15C11.3787 15 10.875 15.5037 10.875 16.125C10.875 16.7463 11.3787 17.25 12 17.25Z",
    fill: "#CE3637"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOctagon);
export default __webpack_public_path__ + "static/media/warningOctagon.c5ce1c7628521188ba5edc52639b751c192389d1ee41b7a8bf9bf93915951070.svg";
export { ForwardRef as ReactComponent };